// extracted by mini-css-extract-plugin
export default {"background":"style_background__v-JnC","main":"style_main__uQXTd","close":"style_close__jXI6C","img":"style_img__54+ql","title":"style_title__VezYi","btn":"style_btn__1ZtKP"};